import React, { useEffect, useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { BreadcrumbOfficeDetail } from '../common';
import Details from './Details.component';
import SimilarProperties from './SimilarProperties.component';
import { getIdDetail, getLanguage, getPathLanguage } from '../../../utils/params';

const OfficeDetailComponent = props => {
  const location = useLocation();
  const language = getLanguage(location);
  const pathLanguage = getPathLanguage(location);
  const id = getIdDetail(location);
  const { detail, similarProperties, error } = props.officeDetail;
  const params = useParams();

  useEffect(() => {
    if (id) {
      let isPreview = params.slug === 'isPreview';
      props.getOfficeDetailRequest({ id, language, isPreview });
      if(!isPreview){
        props.getSimilarListRequest({ currentId: id, 
          language, propertiesType: 2, pageIndex: 1, pageSize: 6 });
      }   
    }
    window.scrollTo(0, 0);

    // eslint-disable-next-line
  }, [id]);

  const renderData = useMemo(() => {
    if (detail) {
      return (
        <>
          <BreadcrumbOfficeDetail allState={props} data={detail} />
          <Details data={detail} />
          <SimilarProperties data={similarProperties || []} />
        </>
      );
    } else if (error && (error.response.status === 404 || error.response.status === 400)) {
      window.location.href = pathLanguage ? pathLanguage : '/';
    }
  }, [props, detail, error, pathLanguage, similarProperties]);

  return <>{renderData}</>;
};

export default OfficeDetailComponent;
